import type { UsageResponse } from "../types"

type UploadUsage = UsageResponse["upload_usage"]

export function getUploadMinutesDisplay(
  usage: UploadUsage,
  recordedMinutes: number | null | undefined,
) {
  const meter =
    usage?.minutes.dimension === "minutes" && usage.minutes.unit === "minute"
      ? usage.minutes
      : undefined
  const selected =
    usage?.selected_dimension === "minutes" &&
    (usage.policy_source === "current_subscription" ||
      usage.policy_source === "explicit") &&
    meter !== undefined
  const allowance = selected ? meter.allowance : undefined
  const limited =
    allowance?.state === "limited" &&
    typeof allowance.quantity === "number" &&
    Number.isFinite(allowance.quantity) &&
    allowance.quantity >= 0
  const unlimited =
    allowance?.state === "unlimited" && allowance.quantity === null
  const limitUnavailable = !limited && !unlimited

  return {
    used: meter?.used_quantity ?? recordedMinutes,
    limit: limited ? allowance.quantity : unlimited ? null : undefined,
    projected: limitUnavailable ? null : (meter?.projected_quantity ?? null),
    limitUnavailable,
  }
}
